// extracted by mini-css-extract-plugin
export default {"container":"Info_container__pucsZ","box":"Info_box__CAeLp","boxText":"Info_boxText__Tiu5f"};